<template>
  <div class="main">
    <canvas id="canvas" width="400" height="350"></canvas>
    <p class="score-tips">信用分是根据网络行为大数据出具的信用评估参考分数</p>
    <div id="text" class="text">
      <div class="text-title">
        <div class="text-title-k"></div>
        <div class="text-title-text">查询内容</div>
      </div>
      <div id="text-item">
        <div class="text-item-item">
          <div class="text-item-item-left">基本信息</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">非银申请记录</div>
          <div class="text-item-item-right fx-color">风险</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">网贷高风险名单</div>
          <div class="text-item-item-right fx-color">风险</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">借贷执行信息</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">法院公告</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">法院开庭公告</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">法院限高</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">法院高风险名单</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">法院案件流程</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">法院其他文书</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">刑事裁判文书</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">执行曝光台</div>
          <div class="text-item-item-right">正常</div>
        </div>
        <div class="text-item-item">
          <div class="text-item-item-left">其他风险监测</div>
          <div class="text-item-item-right fx-color">风险</div>
        </div>
      </div>
      <div class="bottom-title">数据报告说明</div>
      <div class="bottom-text">
        大数据由用户本人授权查询，数据来源于各种社交平台、网贷平台，本平台只做大数据的获取与分析，本报告仅供参考使用，不对数据来源做任何解释。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        docname: '',
        docnumber: '',
        bank: ''
      },
      showOverlay: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCanvas()
    })
  },
  methods: {
    setCanvas() {
      var canvas = document.getElementById('canvas'),
        ctx = canvas.getContext('2d'),
        cWidth = canvas.width,
        cHeight = canvas.height,
        score = Math.floor(Math.random() * (600 - 500 + 1) + 500),
        stage = ['较差', '中等', '良好', '优秀', '极好'],
        radius = 150,
        deg0 = Math.PI / 9,
        deg1 = Math.PI * 11 / 45;
      if (score < 400 || score > 900) {
        alert('信用分数区间：400~900');
      } else {
        var dot = new Dot(),
          dotSpeed = 0.03,
          textSpeed = Math.round(dotSpeed * 100 / deg1),
          angle = 0,
          credit = 10;
        (function drawFrame() {
          ctx.save();
          ctx.clearRect(0, 0, cWidth, cHeight);
          ctx.translate(cWidth / 2, cHeight / 2);
          ctx.rotate(8 * deg0);

          dot.x = radius * Math.cos(angle);
          dot.y = radius * Math.sin(angle);

          var aim = (score - 400) * deg1 / 100;
          var myDate = new Date();
          if (angle < aim) {
            angle += dotSpeed;
          }
          dot.draw(ctx);

          if (credit < score - textSpeed) {
            credit += textSpeed;
          } else if (credit >= score - textSpeed && credit < score) {
            credit += 1;
          }
          text(credit);

          ctx.save();
          ctx.beginPath();
          ctx.lineWidth = 3;
          ctx.strokeStyle = 'rgba(255, 255, 255, .5)';
          ctx.arc(0, 0, radius, 0, angle, false);
          ctx.stroke();
          ctx.restore();

          window.requestAnimationFrame(drawFrame);

          ctx.save(); //中间刻度层
          ctx.beginPath();
          ctx.strokeStyle = 'rgba(255, 255, 255, .2)';
          ctx.lineWidth = 10;
          ctx.arc(0, 0, 135, 0, 11 * deg0, false);
          ctx.stroke();
          ctx.restore();

          ctx.save(); // 刻度线
          for (var i = 0; i < 6; i++) {
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'rgba(255, 255, 255, .3)';
            ctx.moveTo(140, 0);
            ctx.lineTo(130, 0);
            ctx.stroke();
            ctx.rotate(deg1);
          }
          ctx.restore();

          ctx.save(); // 细分刻度线
          for (i = 0; i < 25; i++) {
            if (i % 5 !== 0) {
              ctx.beginPath();
              ctx.lineWidth = 2;
              ctx.strokeStyle = 'rgba(255, 255, 255, .1)';
              ctx.moveTo(140, 0);
              ctx.lineTo(133, 0);
              ctx.stroke();
            }
            ctx.rotate(deg1 / 5);
          }
          ctx.restore();

          ctx.save(); //信用分数
          ctx.rotate(Math.PI / 2);
          for (i = 0; i < 6; i++) {
            ctx.fillStyle = 'rgba(255, 255, 255, .4)';
            ctx.font = '10px Microsoft yahei';
            ctx.textAlign = 'center';
            ctx.fillText(400 + 100 * i, 0, -115);
            ctx.rotate(deg1);
          }
          ctx.restore();

          ctx.save(); //分数段
          ctx.rotate(Math.PI / 2 + deg0);
          for (i = 0; i < 5; i++) {
            ctx.fillStyle = 'rgba(255, 255, 255, .4)';
            ctx.font = '10px Microsoft yahei';
            ctx.textAlign = 'center';
            ctx.fillText(stage[i], 5, -115);
            ctx.rotate(deg1);
          }
          ctx.restore();

          ctx.save(); //信用阶段及评估时间文字
          ctx.rotate(10 * deg0);
          ctx.fillStyle = '#fff';
          ctx.font = '28px Microsoft yahei';
          ctx.textAlign = 'center';
          if (score < 500) {
            ctx.fillText('信用较差', 0, 35);
          } else if (score < 600 && score >= 500) {
            ctx.fillText('信用中等', 0, 35);
          } else if (score < 700 && score >= 600) {
            ctx.fillText('信用良好', 0, 35);
          } else if (score < 800 && score >= 700) {
            ctx.fillText('信用优秀', 0, 35);
          } else if (score <= 900 && score >= 800) {
            ctx.fillText('信用极好', 0, 35);
          }

          ctx.fillStyle = '#80cbfa';
          ctx.font = '14px Microsoft yahei';
          ctx.fillText('评估时间：' + myDate.toLocaleDateString(), 0, 60);

          ctx.fillStyle = '#7ec5f9';
          ctx.font = '14px Microsoft yahei';
          ctx.fillText('BETA', 0, -60);
          ctx.restore();

          // ctx.save(); //最外层轨道
          ctx.beginPath();
          ctx.strokeStyle = 'rgba(255, 255, 255, .4)';
          ctx.lineWidth = 3;
          ctx.arc(0, 0, radius, 0, 11 * deg0, false);
          ctx.stroke();
          ctx.restore();

        })();
      }

      function Dot() {
        this.x = 0;
        this.y = 0;
        this.draw = function (ctx) {
          ctx.save();
          ctx.beginPath();
          ctx.fillStyle = 'rgba(255, 255, 255, .7)';
          ctx.arc(this.x, this.y, 3, 0, Math.PI * 2, false);
          ctx.fill();
          ctx.restore();
        };
      }

      function text(process) {
        ctx.save();
        ctx.rotate(10 * deg0);
        ctx.fillStyle = 'rgba(255, 255, 255, 1)';
        ctx.font = '60px Microsoft yahei';
        ctx.textAlign = 'center';
        ctx.textBaseLine = 'center';
        ctx.fillText(process, 0, 0);
        ctx.restore();
      }

    }
  }
}
</script>

<style lang="less" scoped>canvas {
  position: relative;
  width: 100%;
  background: -webkit-linear-gradient(top, #0e83f5 0%, #21bdf6 100%);
}

.score-tips {
  position: absolute;
  font-size: 14px;
  color: #fff;
  text-align: center;
  top: 230px;
  width: 100%;
}

#text {
  width: 95%;
  position: absolute;
  background: #fff;
  left: 2.5%;
  top: 300px;
  border-radius: 8px;
  padding: 10px;
  box-sizing: border-box;
  padding-bottom: 20px;
  .text-title {
    display: flex;
    align-items: center;
    .text-title-k {
      width: 2px;
      height: 16px;
      background: #21bdf6;
      margin-right: 4px;
    }
    .text-title-text {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .text-item-item {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    padding-left: 6px;
    .fx-color {
      color: red;
    }
  }
  .bottom-title {
    font-size: 14px;
    text-align: center;
    font-weight: bold;
    margin: 14px 0px 8px 0px;
  }
  .bottom-text {
    font-size: 12px;
    color: #ccc;
  }
}</style>
